import { createAction, props } from '@ngrx/store';
import { leadsListPayload } from './leads.model';

export const fetchLeadsList = createAction('[Data] Fetch Leads List', props<{ payload: leadsListPayload }>());
export const fetchLeadsListSuccess = createAction('[Data] Fetch Leads List Success', props<{ response: any }>());
export const fetchLeadsListFailure = createAction('[Data] Fetch Leads List Failure', props<{ error: string }>());

export const assignAgentLead = createAction('[Data] Assign Agent Lead', props<{ payload: any }>());
export const assignAgentLeadSuccess = createAction('[Data] Assign Agent Lead Success', props<{ response: any }>());
export const assignAgentLeadFailure = createAction('[Data] Assign Agent Lead Failure', props<{ error: string }>());
